import { Box, GridItem, PhoneField, Button, validatePhone } from '@flos/react-ui';
import { useHippoText } from '../../../hooks/useHippoText';
import { accountHolderAtom } from '../../../recoil/atoms/accountHolderAtom';
import { useRecoilValue } from 'recoil';
import { topConfigContextAtom } from '../../../recoil/atoms/topConfigContextAtom';
import { useState } from 'react';
import { getPaymentMethod } from '../../../constants/coverable';
import DOMPurify from 'dompurify';
// TODO TZ2: Use new Flos component Pay with MobilePay button
// import VippsMobilePayButton from './components/VippsMobilePayButton';

const MPSVariantBox = ({
    variant,
    otherPaymentMethod,
    handleConfirmToPay
}: {
    variant: 'New' | 'Active' | 'OtherPayment' | 'CancelledPolicy';
    otherPaymentMethod?: string;
    handleConfirmToPay?: (phoneNumber: string) => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const accountHolderData = useRecoilValue(accountHolderAtom);
    const [phoneNumber, setPhoneNumber] = useState(accountHolderData.phoneNumber);
    const topConfigContext = useRecoilValue(topConfigContextAtom);
    const isNotMPSPayment = variant === 'OtherPayment';
    const mitTopDKHostURL = topConfigContext?.siteConfig?.scope?.includes('mit.')
        ? ''
        : `//${topConfigContext?.siteConfig?.sisterHost ?? ''}`;
    const handleBackToFrontPage = (): void => {
        window.location.href = `${mitTopDKHostURL}/`;
    };
    const handleGoToInsuranceListPage = (): void => {
        window.location.href = `${mitTopDKHostURL}/forsikringer/`;
    };
    const handleGoToPaymentOverviewPage = (): void => {
        window.location.href = `${mitTopDKHostURL}/betaling/`;
    };
    const handlePhoneNumberChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        setPhoneNumber(event.target.value);
    };
    const onClickToPayMps = (): void => {
        if (handleConfirmToPay) {
            handleConfirmToPay(phoneNumber ?? '');
        }
    };

    const getInfoText = (): { header: string; subheader: string } => {
        switch (variant) {
            case 'Active':
                return {
                    header: getHippoText('DSS-MPS-FLOW-CREATE-AGREEMENT-SECTION-HEADER-ACTIVE-MPS'),
                    subheader: getHippoText(
                        'DSS-MPS-FLOW-CREATE-AGREEMENT-SECTION-SUBHEADER-ACTIVE-MPS'
                    )
                };
            case 'OtherPayment':
                return {
                    header: getHippoText(
                        'DSS-MPS-FLOW-CREATE-AGREEMENT-SECTION-HEADER-OTHER-PAYMENT-METHOD-NOT-MPS'
                    ),
                    subheader: getHippoText(
                        'DSS-MPS-FLOW-CREATE-AGREEMENT-SECTION-SUBHEADER-OTHER-PAYMENT-METHOD-NOT-MPS',
                        { payment_method: getPaymentMethod(otherPaymentMethod) }
                    )
                };
            case 'CancelledPolicy':
                return {
                    header: getHippoText(
                        'DSS-MPS-FLOW-CREATE-AGREEMENT-SECTION-HEADER-CANCELLED-POLICY'
                    ),
                    subheader: getHippoText(
                        'DSS-MPS-FLOW-CREATE-AGREEMENT-SECTION-SUBHEADER-CANCELLED-POLICY'
                    )
                };
            default:
                return {
                    header: getHippoText(
                        'DSS-MPS-FLOW-CREATE-AGREEMENT-SECTION-HEADER-NON-ACTIVE-MPS'
                    ),
                    subheader: getHippoText(
                        'DSS-MPS-FLOW-CREATE-AGREEMENT-SECTION-SUBHEADER-NON-ACTIVE-MPS'
                    )
                };
        }
    };
    const { header, subheader } = getInfoText();
    return (
        <Box padding="large" className="u-spacing-stack-l">
            {!['OtherPayment', 'CancelledPolicy'].includes(variant) && (
                <Box
                    padding={'xlarge'}
                    className="u-bg-supplement-grey-light flos-box--center-children u-shadow-none"
                >
                    <img
                        alt="MobilePay"
                        src={`${topConfigContext?.resourceUrl ?? ''}/images/mobile-pay-blue.svg`}
                    />
                </Box>
            )}
            <div className="u-spacing-inset-m--stretch-max">
                <h4>{header}</h4>
                <p
                    className="u-spacing-stack-sm"
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(subheader)
                    }}
                />
            </div>
            {variant === 'New' && (
                <>
                    <GridItem span={12}>
                        <PhoneField
                            label={getHippoText('DSS-CONTACT-INFORMATION-PHONE')}
                            name="phoneNumber"
                            value={phoneNumber}
                            onChange={handlePhoneNumberChange}
                            required={true}
                        />
                    </GridItem>
                    <div className="u-spacing-inset-bottom-4 u-spacing-inset-bottom-none@xl">
                        <Button
                            minWidth="wider"
                            onClick={onClickToPayMps}
                            disabled={!validatePhone(phoneNumber?.replaceAll(' ', ''))}
                        >
                            Betal med MobilePay
                        </Button>
                        <Button onClick={handleBackToFrontPage} theme="ghost">
                            {getHippoText('DSS-MPS-FLOW-CREATE-AGREEMENT-SECTION-BACK-BUTTON')}
                        </Button>
                    </div>
                </>
            )}
            {variant !== 'New' && (
                <GridItem span={12}>
                    <div className="u-spacing-inset-bottom-4 u-spacing-inset-bottom-none@xl">
                        <Button
                            onClick={
                                isNotMPSPayment
                                    ? handleGoToPaymentOverviewPage
                                    : handleGoToInsuranceListPage
                            }
                        >
                            {getHippoText(
                                isNotMPSPayment
                                    ? 'DSS-MPS-FLOW-CREATE-AGREEMENT-SECTION-GO-TO-PAYMENT-OVERVIEW-PAGE-BUTTON'
                                    : 'DSS-MPS-FLOW-CREATE-AGREEMENT-SECTION-GO-TO-POLICY-DETAIL-PAGE-BUTTON'
                            )}
                        </Button>
                        <Button onClick={handleBackToFrontPage} theme="ghost">
                            {getHippoText('DSS-MPS-FLOW-CREATE-AGREEMENT-SECTION-BACK-BUTTON')}
                        </Button>
                    </div>
                </GridItem>
            )}
            {/* <VippsMobilePayButton
                disabled={false}
                onClick={() => {}}
            ></VippsMobilePayButton> */}
        </Box>
    );
};

export default MPSVariantBox;
